// src/modules/config/components/filters/ItemsFilters.tsx - ИСПРАВЛЕННАЯ ВЕРСИЯ
import React from 'react';
import { Row, Col, Select, Input, Button } from 'antd';
import { MenuCategory } from '@/types';

const { Search } = Input;

interface ItemsFiltersProps {
  categories: MenuCategory[];
  filters: {
    categoryIds: number[];
    status: string;
    search: string;
    hasDiscount?: boolean;
    hasQrCode?: boolean;
  };
  onFilterChange: (key: string, value: any) => void;
  onClearFilters: () => void;
}

export const ItemsFilters: React.FC<ItemsFiltersProps> = ({
  categories,
  filters,
  onFilterChange,
  onClearFilters
}) => {
  
  // ИСПРАВЛЕНИЕ: Обработчик для поиска с дебаунсом
  const handleSearchChange = (value: string) => {
    // Немедленно обновляем локальное состояние для отзывчивости интерфейса
    onFilterChange('search', value);
  };

  // ИСПРАВЛЕНИЕ: Обработчик для поиска при нажатии Enter или кнопки поиска
  const handleSearch = (value: string) => {
    onFilterChange('search', value);
  };

  return (
    <Row gutter={[8, 8]} style={{ marginBottom: 16 }}>
      <Col xs={24} sm={12} md={8} lg={6} xl={6}>
        <Select
          // ИСПРАВЛЕНИЕ: Убираем множественный режим для одиночного выбора
          // mode="multiple" // ← УБРАНО для одиночного выбора
          placeholder="Выберите категорию"
          allowClear
          style={{ width: '100%' }}
          value={filters.categoryIds.length > 0 ? filters.categoryIds[0] : undefined}
          onChange={(value) => onFilterChange('categoryIds', value ? [value] : [])}
          showSearch
          filterOption={(input, option) =>
            (option?.children as unknown as string).toLowerCase().includes(input.toLowerCase())
          }
        >
          {categories.map(category => (
            <Select.Option key={category.id} value={category.id}>
              {category.parent ? `— ${category.name}` : category.name}
            </Select.Option>
          ))}
        </Select>
      </Col>
      
      <Col xs={12} sm={6} md={4} lg={3} xl={3}>
        <Select
          placeholder="Статус"
          allowClear
          style={{ width: '100%' }}
          value={filters.status || undefined}
          onChange={(value) => onFilterChange('status', value || '')}
        >
          <Select.Option value="active">Активные</Select.Option>
          <Select.Option value="discontinued">Снятые</Select.Option>
        </Select>
      </Col>
      
      <Col xs={12} sm={6} md={4} lg={3} xl={3}>
        <Select
          placeholder="QR-коды"
          allowClear
          style={{ width: '100%' }}
          value={filters.hasQrCode}
          onChange={(value) => onFilterChange('hasQrCode', value)}
        >
          <Select.Option value={true}>С QR-кодами</Select.Option>
          <Select.Option value={false}>Без QR-кодов</Select.Option>
        </Select>
      </Col>
      
      <Col xs={24} sm={12} md={6} lg={6} xl={6}>
        {/* ИСПРАВЛЕНИЕ: Улучшенный поиск */}
        <Search
          placeholder="Поиск по названию или артикулу"
          allowClear
          value={filters.search}
          onChange={(e) => handleSearchChange(e.target.value)}
          onSearch={handleSearch}
          onClear={() => handleSearchChange('')}
          enterButton
        />
      </Col>
      
      <Col xs={24} sm={12} md={2} lg={3} xl={3}>
        <Button onClick={onClearFilters} block>
          Очистить
        </Button>
      </Col>
    </Row>
  );
};